import { useConfig } from '../../../../containers/configs/_load/ConfigsLoader'
import { CHECKLIST_MAX_QUESTIONS_CONFIG_NAME, DEFAULT_MAX_QUESTIONS } from '../_constants/questions'

// Per-workspace override for the checklist questions limit, set via the `checklist_max_questions`
// Config (same key/value store used by `service_order_sla`, etc). Falls back to
// DEFAULT_MAX_QUESTIONS when the workspace has no config for it.
export const useMaxQuestions = () => {
  const config = useConfig(CHECKLIST_MAX_QUESTIONS_CONFIG_NAME)
  const configuredValue = Number(config?.value)

  return Number.isFinite(configuredValue) && configuredValue > 0 ? configuredValue : DEFAULT_MAX_QUESTIONS
}
